<template>
  <div class="banner">
    <p class="banner-text">
      {{ addDotsInNumber(houseCountVariable) }} {{ true === showRentalType ? rentalTypeName() : resultsName(houseCountVariable) }}  {{ true === showCityName ? ' in ' + location : '' }}
    </p>
    <adivare-login-house-count-text></adivare-login-house-count-text>
  </div>
</template>

<script>
import shared from '../../../../../common/vue/components/search/text/shared';
import AdivareLoginHouseCountText from "./login-house-count-text.vue";

export default {
  name: "adivare-text-banner",
  components: {
    AdivareLoginHouseCountText,
  },
  props: {
    countExpected: {
      type: Boolean,
      default: false,
      required: false
    },
    showRentalType: {
      type: Boolean,
      default: false,
      required: false
    },
    showCityName: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  extends: shared,
  computed: {
    houseCountVariable() {
      if (true === this.countExpected && undefined !== this.houseCountExpected) {
        return this.houseCountExpected;
      } else {
        return this.houseCount;
      }
    }
  }
}
</script>
